import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { count } from 'rxjs';
//import { swipe } from '../utilities/swipe';

@Component({
  selector: 'app-ops-app-shell',
  templateUrl: './ops-app-shell.component.html',
  styleUrls: ['./ops-app-shell.component.css']
})
export class OpsAppShellComponent implements OnInit {
  items: MenuItem[] | undefined;
  activeItemIndex: number = 1;

  //private swipeCoord?: [number, number];
  //private swipeTime?: number;

  constructor(private router: Router,
    private route: ActivatedRoute){}

  activeItem: MenuItem | undefined;
  ngOnInit(){
    this.items = [
      { label: 'Worklist', routerLink: 'worklist-list', icon: 'pi pi-fw pi-th-large' },
      { label: 'Incidents', routerLink: 'incidents', icon: 'pi pi-fw pi-exclamation-circle' },
      { label: 'Instruments', routerLink: 'instrument-categories', icon: 'pi pi-fw pi-print' },
      //{ label: 'GoFMX', routerLink: 'go-fmx', icon: 'pi pi-fw pi-building' },
      { label: 'Sensors', routerLink: 'sensors', icon: 'pi pi-fw pi-bell' },
      { label: 'Dashboard', routerLink: 'ops-dashboard', icon: 'pi pi-fw pi-images' },
      { label: 'Gure', routerLink: 'gure-dashboard', icon: 'pi pi-fw pi-chart-line' },
      { label: 'Instrudex', routerLink: '/config', icon: 'pi pi-fw pi-home' }
    ];
    this.updateActiveItemIndex();
  }

  updateActiveItemIndex(){
    this.activeItem = this.items.find(x => this.router.url.includes(x.routerLink));

    if (this.activeItem != undefined){
      this.activeItemIndex = this.items.findIndex(x => this.activeItem.routerLink === x.routerLink);
    }
  }

  // swipe(e: TouchEvent, when: string): void {
  //   if (this.activeItemIndex == -1)
  //     return;

  //   const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
  //   const time = new Date().getTime();

  //   if (when === 'start') {
  //     this.swipeCoord = coord;
  //     this.swipeTime = time;
  //   } else if (when === 'end') {
  //     const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
  //     const duration = time - this.swipeTime;

  //     if (duration < 1000 //
  //       && Math.abs(direction[0]) > 30 // Long enough
  //       && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
  //         const swipe = direction[0] < 0 ? 'next' : 'previous';
  //         if (swipe === 'next' && this.activeItemIndex < this.items.length - 1){
  //           this.activeItemIndex++;
  //           this.activeItem = this.items[this.activeItemIndex]
  //           this.router.navigate([this.activeItem.routerLink], { relativeTo: this.route });
  //         }
  //         if (swipe === 'previous' && this.activeItemIndex > 0)
  //         {
  //           this.activeItemIndex--;
  //           this.activeItem = this.items[this.activeItemIndex]
  //           this.router.navigate([this.activeItem.routerLink], { relativeTo: this.route });
  //         }
  //     }
  //   }
  // }

  onActiveItemChange(event: any){
    this.activeItem = event;
    this.activeItemIndex = this.items.findIndex(x => this.activeItem.routerLink === x.routerLink);
  }
}
